module.exports = __webpack_public_path__ + "static/becoming-steve-jobs-d5c12bb64a17b782efb0f91c1e1bb720.jpg";